import React from "react";
import UpdateDetailContainer from "./updateDetail";
import Footer from '../../../navigation/footerContainer';

export default function UpdateBuyerDetailPage() {
    return(

        <>
            <UpdateDetailContainer />
            <Footer />
        </>

    )
}